module.exports = __webpack_public_path__ + "media/images/whatsapp_white-9341aeba0f1d41f8ffa1e57cf508afa6.png";